/**
 * The kinds of note locked to their own kind: the Session type shows as a read-only box with the
 * kind's name instead of the appointment type picker (ehr#708 DISCHARGE_SUMMARY_NOTE_10-30-V5,
 * ehr#726 PSYCH_TESTING_NOTE_10-30-V4 and ehr#727 PEER_SUPPORT_NOTE_10-30-V8, "Locked to that type").
 */
export const TYPE_LOCKED_KINDS: readonly string[] = [
  'Discharge summary',
  'Psych testing',
  'Peer support',
];

/** Whether the note's Session type is the read-only kind box. */
export const typeLocked = (kind: string): boolean => TYPE_LOCKED_KINDS.includes(kind);
